module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "nav"
  }, [_c('ul', [_vm._l((_vm.data), function(obj) {
    return [_c('router-link', {
      staticClass: "link-li",
      attrs: {
        "exact": true,
        "to": obj.path,
        "tag": "li"
      }
    }, [_vm._v("\n        " + _vm._s(obj.name) + "\n        "), _c('small', [_vm._v(_vm._s(obj.cn_name))])]), _vm._v(" "), _vm._l((obj.child), function(child_obj) {
      return (obj.child) ? _c('div', {
        staticClass: "nav-child-wrap"
      }, [_c('div', {
        staticClass: "nav-child-title"
      }, [_vm._v(_vm._s(child_obj.title))]), _vm._v(" "), _vm._l((child_obj.components), function(component_obj, i) {
        return _c('router-link', {
          key: i,
          staticClass: "nav-child link-li",
          attrs: {
            "exact": true,
            "to": obj.path + component_obj.path,
            "tag": "li"
          }
        }, [_vm._v("\n          " + _vm._s(component_obj.name) + "\n          "), _c('small', [_vm._v(_vm._s(component_obj.cn_name))])])
      })], 2) : _vm._e()
    })]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e3d8332"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/Nav.vue
// module id = 628
// module chunks = 0